export class APIError extends Error {
  static readonly messageFallback = 'Ops! Algo deu errado'
  static readonly descriptionFallback = 'Houve um erro! Tente novamente ou contate o suporte.'

  readonly description: string
  readonly code?: number
  readonly cause?: unknown

  constructor({
    code,
    message,
    name,
    description,
    cause,
  }: {
    message: string
    description: string
    code?: number
    name?: string
    cause?: unknown
  }) {
    super(message)
    this.name = name ?? this.constructor.name

    this.description = description
    this.code = code
    this.cause = cause
  }
}
